var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1011 18.8989C9.30114 18.8989 8.00114 18.7992 6.60114 18.1992C4.20114 17.1992 3.00116 15.4989 2.50116 14.8989C2.00116 14.0989 1.60116 13.4992 1.50116 13.1992C0.80116 11.4992 0.701172 10.0991 0.701172 9.59912C0.701172 6.69912 2.10116 4.59912 2.50116 4.09912C2.70116 3.79912 3.40114 2.89912 4.60114 2.09912C6.70114 0.599121 8.90116 0.398828 10.0012 0.298828C10.9012 0.298828 12.6012 0.398926 14.4012 1.39893C16.9012 2.69893 18.0012 4.79912 18.4012 5.59912C19.2012 7.29912 19.3011 8.79912 19.3011 9.59912C19.4011 10.9991 19.5012 13.9989 17.4012 16.3989C14.8012 19.3989 10.6011 18.8989 10.1011 18.8989Z",
    fill: "#FFB100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50079 13.6987V10.4985H6.30078V8.59863H9.50079V5.39844H11.4008V8.59863H14.6008V10.4985H11.4008V13.6987H9.50079Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.0e7d347d5776727c7784aab908b1578b.svg";
export { ForwardRef as ReactComponent };